export default __webpack_public_path__ + "static/media/triobanner.86dc69b2.png";